import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {fetchData, fetchDataNew, fetchList, fetchListNew} from "../../hook/axios.hook";

import {addNewFinOrder, fetchFinOrder} from "./FinSettings/FinSettingsSlice";

const initialState = {
  cashdeskDirective: null,
  bankTransactions: [],
  bankClientStatements: [],
  bankTransaction: null,
  bankClientFilters: [],
  counterpartyTypes: [],
  turnovers: [],
  currentVedDirectiveId: null,
  currentVedOrderId: null,
  currentCargoDirectiveId: null,
  currentCargoOrderId: null,

  manualTransactions: [],
  // manualTransaction: [],

  vedDirectives: [],
  vedDirectivesFilters: {},
  currentVedDirective: null,

  cargoDirectives: [],
  cargoDirectivesFilters: {},
  currentCargoDirective: null,

  statementDirectives: [],
  statementDirectivesFilters: {},
  currentStatementDirective: null,

  paymentDocTypes: [],
  paymentDocs: [],
  payments: [],
  currentDocId: null,
  currentPaymentId: null,
  currentPaymentDocument: null,
  currentSchema: null,

  rateMatrix: null,

  allExchanges: [],
  exchange: null,

  loading: false,
  error: false,

  currentDirectiveId: null,
  currentOrderId: null,
};

//*** Operations ***

export const addNewCashdeskDirective = createAsyncThunk("finBlock/addNewCashdeskDirective", async body => {
  return fetchData(`/finance/directives/addForCashdesk`, "post", body);
});

///***  Bank Client */
export const uploadBankClientStatements = createAsyncThunk("finBlock/uploadBankClientStatements", async formdata => {
  return fetchData(`/finance/bankClient/upload`, "post", formdata);
});

export const fetchAllBankClientStatements = createAsyncThunk("finBlock/fetchAllBankClientStatements", async params => {
  return fetchList(`/finance/bankClient/statements/getAll`, "get", {params: {...params}});
});

export const fetchAllBankTransactions = createAsyncThunk("finBlock/fetchAllBankTransactions", async params => {
  return fetchList(`/finance/bankClient/bankTransactions/getAll`, "get", {params: {...params}});
});

export const fetchAllAccountsBalances = createAsyncThunk("finBlock/fetchAllAccountsBalances", async params => {
  return fetchList(`/finance/bankClient/accountBalances`, "get", {params: {...params}});
});

export const fetchBankClientFilters = createAsyncThunk("finBlock/fetchBankClientFilters", async () => {
  return fetchData(`/finance/bankClient/getFilters`, "get");
});

export const fetchAllCounterpartyTypes = createAsyncThunk("finBlock/fetchAllCounterpartyTypes", async () =>
  fetchList(`/finance/bankClient/counterpartyTypes/getAll`, "get"),
);

export const fetchBankTransaction = createAsyncThunk("finBlock/fetchBankTransaction", async ({id}) => {
  return fetchList(`/finance/bankClient/bankTransactions/${id}`);
});

export const alignCounterpartyAcc = createAsyncThunk(
  "finBlock/alignCounterpartyAcc",
  async ({id, clientId, directiveId, accountTypeId}, {rejectWithValue}) => {
    return fetchDataNew(`/finance/bankClient/bankTransactions/align/${id}`, "patch", {
      body: {clientId, directiveId, accountTypeId},
      rejectWithValue,
    });
  },
);

export const alignUntilFurtherNotice = createAsyncThunk("finBlock/alignUntilFurtherNotice", async ({id, clientId}) => {
  return fetchData(`/finance/bankClient/bankTransactions/alignUntilFurtherNotice/${id}`, "post", {clientId});
});

export const completeBankTransaction = createAsyncThunk("finBlock/completeBankTransaction", async id =>
  fetchData(`/finance/bankClient/bankTransactions/complete/${id}`, "post"),
);

//*** External accaounts */
export const createExternalAccount = createAsyncThunk("finBlock/createExternalAccount", async body => {
  return fetchData(`/finance/externalAccounts`, "post", body);
});

//*** Manual transactions */
export const fetchAllManualTransactions = createAsyncThunk("finBlock/fetchAllManualTransactions", async () => {
  return fetchList(`/finance/bankClient/manual`, "get");
});
export const createManualTransaction = createAsyncThunk("finBlock/createManualTransaction", async () => {
  return fetchData(`/finance/bankClient/manual`, "post");
});

export const saveManualTransaction = createAsyncThunk("finBlock/saveManualTransaction", async ({statementId, body}) =>
  fetchData(`/finance/bankClient/manual/${statementId}`, "patch", body),
);
export const completeManualTransaction = createAsyncThunk(
  "finBlock/completeManualTransaction",
  async (statementId, {rejectWithValue}) =>
    fetchDataNew(`/finance/bankClient/manual/${statementId}/complete`, "patch", {rejectWithValue}),
);
export const cancelManualTransaction = createAsyncThunk("finBlock/cancelManualTransaction", async statementId =>
  fetchData(`/finance/bankClient/manual/${statementId}/cancel`, "patch", null, null, false, null, true),
);

//*** VED Directives ***/
export const fetchAllVedDirectives = createAsyncThunk(
  "finBlock/fetchAllVedDirectives",
  async ({signal, ...params}, {rejectWithValue}) => {
    return fetchListNew(`/finance/directives/fea`, "get", {rawBody: {params, signal}, rejectWithValue});
  },
);

export const fetchVedDirective = createAsyncThunk("finBlock/fetchVedDirective", async directiveId => {
  return fetchData(`/finance/directives/get/${directiveId}`, "get");
});

export const fetchVedDirectivesFilters = createAsyncThunk("finBlock/fetchVedDirectivesFilters", async params => {
  return fetchList(`/finance/directives/fea/filters`, "get", {params});
});
// export const updateVedDirective = createAsyncThunk("finBlock/updateVedDirective", async body =>
//   fetchData(`/finance/directives/ved/update`, "patch", body),
// );
export const updateVedPayment = createAsyncThunk("finBlock/updateVedPayment", async body =>
  fetchData(`/finance/directives/ved/payment`, "patch", body),
);
export const completeVedPayment = createAsyncThunk("finBlock/completeVedPayment", async paymentId =>
  fetchData(`/finance/directives/ved/payment/complete/${paymentId}`, "patch"),
);
export const clearVedPayment = createAsyncThunk("finBlock/clearVedPayment", async paymentId =>
  fetchData(`/finance/directives/ved/payment/clear/${paymentId}`, "patch"),
);
export const uploadVedPaymentDoc = createAsyncThunk("finBlock/uploadVedPaymentDoc", async formData =>
  fetchData(`/finance/directives/ved/document`, "post", formData),
);
export const deleteVedPaymentDoc = createAsyncThunk("finBlock/deleteVedPaymentDoc", async docId =>
  fetchData(`/finance/directives/ved/document/${docId}`, "delete"),
);

export const fetchVedPaymentDocTypes = createAsyncThunk("finBlock/fetchVedPaymentDocTypes", async ({window} = {}) => {
  return fetchListNew(`/references/paymentDocTypes`, "get", {params: {window}});
});

//*** Cargo Directives ***/
export const fetchAllCargoDirectives = createAsyncThunk(
  "finBlock/fetchAllCargoDirectives",
  async ({...params}, {signal, rejectWithValue}) => {
    return fetchListNew(`/finance/directives/cargo`, "get", {rawBody: {params, signal}, rejectWithValue});
  },
);
export const fetchAllStatementDirectives = createAsyncThunk(
  "finBlock/fetchAllStatementDirectives",
  async ({...params}, {signal, rejectWithValue}) => {
    return fetchListNew(`/finance/directives/statement`, "get", {rawBody: {params, signal}, rejectWithValue});
  },
);
export const fetchAllFinanceDirectives = createAsyncThunk(
  "finBlock/fetchAllFinanceDirectives",
  async ({ownerType, signal, ...params}, {rejectWithValue}) => {
    if (!ownerType) return;
    return fetchListNew(`/finance/directives/${ownerType}`, "get", {rawBody: {params, signal}, rejectWithValue});
  },
);
export const fetchCargoDirective = createAsyncThunk("finBlock/fetchCargoDirective", async directiveId => {
  return fetchData(`/finance/directives/get/${directiveId}`, "get");
});
export const fetchCargoDirectivesFilters = createAsyncThunk("finBlock/fetchCargoDirectivesFilters", async params => {
  return fetchList(`/finance/directives/cargo/filters`, "get", {params});
});
export const fetchStatementDirectivesFilters = createAsyncThunk(
  "finBlock/fetchStatementDirectivesFilters",
  async params => {
    return fetchList(`/finance/directives/statement/filters`, "get", {params});
  },
);
export const linkDirective = createAsyncThunk("finBlock/linkDirective", async body => {
  return fetchDataNew(`/finance/directives/link`, "patch", {rawBody: body});
});
export const unlinkDirective = createAsyncThunk("finBlock/unlinkDirective", async body =>
  fetchDataNew(`/finance/directives/unlink`, "patch", {rawBody: body}),
);
export const clearCargoPayment = createAsyncThunk("finBlock/clearCargoPayment", async paymentId =>
  fetchData(`/finance/directives/cargo/payment/clear/${paymentId}`, "patch"),
);
export const updateCargoPayment = createAsyncThunk("finBlock/updateCargoPayment", async body =>
  fetchData(`/finance/directives/cargo/payment`, "patch", body),
);
export const completeCargoPayment = createAsyncThunk("finBlock/completeCargoPayment", async paymentId =>
  fetchData(`/finance/directives/cargo/payment/complete/${paymentId}`, "patch"),
);
export const uploadCargoPaymentDoc = createAsyncThunk("finBlock/uploadCargoPaymentDoc", async formData =>
  fetchData(`/finance/directives/cargo/document`, "post", formData),
);
export const deleteCargoPaymentDoc = createAsyncThunk("finBlock/deleteCargoPaymentDoc", async ({docId, fileId}) =>
  fetchData(`/finance/directives/cargo/document/${docId}/${fileId}`, "delete"),
);

//*** Confirm Payment ***/
export const updateConfirmPayment = createAsyncThunk(
  "finBlock/updateConfirmPayment",
  async ({confirmPaymentId, data}, {rejectWithValue, signal}) =>
    fetchDataNew(`finance/confirmPayments/${confirmPaymentId}`, "patch", {
      rawBody: data,
      rejectWithValue,
      signal,
      noMessage: true,
    }),
);

export const createConfirmPayment = createAsyncThunk(
  "finBlock/createConfirmPayment",
  async ({data}, {rejectWithValue, signal}) =>
    fetchDataNew(`finance/confirmPayments`, "post", {
      rawBody: data,
      rejectWithValue,
      signal,
      noMessage: true,
    }),
);

export const clearConfirmPayment = createAsyncThunk(
  "finBlock/clearConfirmPayment",
  async ({confirmPaymentId}, {rejectWithValue, signal}) =>
    fetchDataNew(`finance/confirmPayments/${confirmPaymentId}/clear`, "patch", {
      rejectWithValue,
      signal,
      noMessage: true,
    }),
);

export const completeConfirmPayment = createAsyncThunk(
  "finBlock/completeConfirmPayment",
  async ({confirmPaymentId}, {rejectWithValue, signal}) =>
    fetchDataNew(`finance/confirmPayments/${confirmPaymentId}/complete`, "patch", {
      rejectWithValue,
      signal,
      noMessage: true,
    }),
);

export const uploadConfirmPaymentFile = createAsyncThunk(
  "finBlock/uploadConfirmPaymentFile",
  async ({confirmPaymentId, data}, {rejectWithValue, signal}) =>
    fetchDataNew(`finance/confirmPayments/${confirmPaymentId}/files`, "post", {
      rawBody: data,
      rejectWithValue,
      signal,
      noMessage: true,
    }),
);

export const removeConfirmPaymentFile = createAsyncThunk(
  "finBlock/removeConfirmPaymentFile",
  async ({fileId}, {rejectWithValue, signal}) =>
    fetchDataNew(`finance/confirmPayments/files/${fileId}`, "delete", {
      rejectWithValue,
      signal,
      noMessage: true,
    }),
);

export const restoreConfirmPaymentFile = createAsyncThunk(
  "finBlock/restoreConfirmPaymentFile",
  async ({fileId}, {rejectWithValue, signal}) =>
    fetchDataNew(`finance/confirmPayments/files/${fileId}/restore`, "patch", {
      rejectWithValue,
      signal,
      noMessage: true,
    }),
);

//*** Payments */
export const PAYMENT_OWNER_TYPES = Object.freeze({
  REQUEST: "request",
  CARGO: "cargo",
  STATEMENT: "statement",
});

export const fetchAllPayments = createAsyncThunk(
  "finBlock/fetchAllPayments",
  async ({ownerType, ownerId, paymentId}, {rejectWithValue, signal}) => {
    if (!ownerType || !ownerId) return;
    return fetchListNew(`finance/paymentDocs/${ownerType}/${ownerId}/payments`, "get", {
      params: {paymentId},
      rejectWithValue,
      signal,
      noMessage: true,
    });
  },
);
export const createPayment = createAsyncThunk(
  "finBlock/createPayment",
  async ({docId, data} = {}, {rejectWithValue, signal}) =>
    fetchDataNew(`finance/paymentDocs/${docId}/payments`, "post", {
      rawBody: data,
      rejectWithValue,
      signal,
      noMessage: true,
    }),
);
export const removePayment = createAsyncThunk(
  "finBlock/removePayment",
  async ({paymentId}, {rejectWithValue, signal}) =>
    fetchDataNew(`finance/paymentDocs/payments/${paymentId}`, "delete", {rejectWithValue, signal, noMessage: true}),
);
export const sendPayment = createAsyncThunk(
  "finBlock/sendPayment",
  async ({paymentId, data}, {rejectWithValue, signal}) =>
    fetchDataNew(`finance/paymentDocs/payments/${paymentId}/send`, "post", {
      rawBody: data,
      rejectWithValue,
      signal,
      noMessage: true,
    }),
);
//** Payment docs */
export const fetchAllPaymentDocs = createAsyncThunk(
  "finBlock/fetchAllPaymentDocs",
  async ({ownerType, ownerId}, {rejectWithValue, signal}) => {
    if (!ownerType || !ownerId) return;
    return fetchListNew(`finance/paymentDocs/${ownerType}/${ownerId}`, "get", {
      rejectWithValue,
      signal,
      noMessage: true,
    });
  },
);
export const fetchPaymentDoc = createAsyncThunk(
  "finBlock/fetchPaymentDoc",
  async ({docId}, {rejectWithValue, signal}) =>
    fetchDataNew(`finance/paymentDocs/${docId}`, "get", {rejectWithValue, signal, noMessage: true}),
);
export const createPaymentDoc = createAsyncThunk(
  "finBlock/createPaymentDoc",
  async ({ownerType, ownerId, data}, {rejectWithValue, signal}) => {
    if (!ownerType || !ownerId) return;
    return fetchDataNew(`finance/paymentDocs/${ownerType}/${ownerId}`, "post", {
      rawBody: data,
      rejectWithValue,
      signal,
      noMessage: true,
    });
  },
);
export const updatePaymentDoc = createAsyncThunk(
  "finBlock/updatePaymentDoc",
  async ({docId, data}, {rejectWithValue, signal}) =>
    fetchDataNew(`finance/paymentDocs/${docId}`, "patch", {rawBody: data, rejectWithValue, signal, noMessage: true}),
);
export const removePaymentDoc = createAsyncThunk(
  "finBlock/removePaymentDoc",
  async ({docId}, {rejectWithValue, signal}) =>
    fetchDataNew(`finance/paymentDocs/${docId}`, "delete", {rejectWithValue, signal, noMessage: true}),
);
export const uploadPaymentDocFile = createAsyncThunk(
  "finBlock/uploadPaymentDocFile",
  async ({docId, data}, {rejectWithValue, signal}) =>
    fetchDataNew(`finance/paymentDocs/${docId}/files`, "post", {
      rawBody: data,
      rejectWithValue,
      signal,
      noMessage: true,
    }),
);
export const removePaymentDocFile = createAsyncThunk(
  "finBlock/removePaymentDocFile",
  async ({fileId}, {rejectWithValue, signal}) =>
    fetchDataNew(`finance/paymentDocs/files/${fileId}`, "delete", {rejectWithValue, signal, noMessage: true}),
);

//*** Cash exchanges */
export const fetchExchange = createAsyncThunk(
  "finBlock/fetchExchange",
  async ({exchangeId}, {rejectWithValue, signal}) => {
    if (!exchangeId) return;
    return fetchDataNew(`finance/exchanges/${exchangeId}`, "get", {
      rejectWithValue,
      signal,
      noMessage: true,
    });
  },
);
export const fetchAllExchanges = createAsyncThunk(
  "finBlock/fetchAllExchanges",
  async (params, {rejectWithValue, signal}) =>
    fetchListNew(`finance/exchanges`, "get", {params, rejectWithValue, signal, noMessage: true}),
);
export const createExchange = createAsyncThunk("finBlock/createExchange", async (body, {rejectWithValue, signal}) => {
  return fetchDataNew(`finance/exchanges`, "post", {
    body,
    rejectWithValue,
    signal,
    noMessage: true,
  });
});
export const updateExchange = createAsyncThunk(
  "finBlock/updateExchange",
  async ({exchangeId, body}, {rejectWithValue, signal}) => {
    if (!exchangeId) return;
    return fetchDataNew(`finance/exchanges/${exchangeId}`, "patch", {
      body,
      rejectWithValue,
      signal,
      noMessage: true,
    });
  },
);
export const runExchange = createAsyncThunk("finBlock/runExchange", async ({exchangeId}, {rejectWithValue, signal}) => {
  if (!exchangeId) return;
  return fetchDataNew(`finance/exchanges/${exchangeId}`, "post", {
    rejectWithValue,
    signal,
    noMessage: true,
  });
});
export const deleteExchange = createAsyncThunk(
  "finBlock/deleteExchange",
  async ({exchangeId}, {rejectWithValue, signal}) => {
    if (!exchangeId) return;
    return fetchDataNew(`finance/exchanges/${exchangeId}`, "delete", {rejectWithValue, signal, noMessage: true});
  },
);

export const FIN_BLOCK_STORE_NAME = "finBlock";

const FinBlockSlice = createSlice({
  name: FIN_BLOCK_STORE_NAME,
  initialState,
  reducers: {
    //**Schema */
    setCurentSchema: (state, {payload}) => {
      state.currentSchema = payload;
    },
    //**Payment document */
    setCurrentDocId: (state, {payload}) => {
      state.currentDocId = payload;
    },
    setCurrentPaymentDocument: (state, {payload}) => {
      if (!payload) return;
      state.currentPaymentDocument = payload;
      state.currentSchema = payload.schemaId;
      state.currentDocId = payload.docId;
    },
    setPaymentDocSelect: (state, {payload}) => {
      state.currentPaymentDocument = state.payments.find(({paymentId}) => paymentId === payload);
      state.currentPaymentId = payload;
    },
    deselectPaymentDoc: state => {
      state.currentPaymentDocument = null;
      state.currentPaymentId = null;
    },
    clearCashdeskDirective: state => {
      state.cashdeskDirective = null;
    },
    // setCurrentDirectiveId: (state, {payload}) => {
    //   state.currentDirectiveId = payload ?? null;
    // },
    setCurrentVedDirectiveId: (state, {payload}) => {
      state.currentVedDirectiveId = payload;
    },
    // setCurrentOrderId: (state, {payload}) => {
    //   state.currentOrderId = payload ?? null;
    // },
    setCurrentVedOrderId: (state, {payload}) => {
      state.currentVedOrderId = payload;
    },
    setCurrentCargoDirectiveId: (state, {payload}) => {
      state.currentCargoDirectiveId = payload;
    },
    setCurrentCargoOrderId: (state, {payload}) => {
      state.currentCargoOrderId = payload;
    },
    clearPayments: state => {
      state.payments = [];
      state.paymentDocs = [];
    },

    //** Rate matrix */
    setRateMatrix: (state, {payload}) => {
      state.rateMatrix = payload;
    },
    clearRateMatrix: state => {
      state.rateMatrix = null;
    },
    setCurrentExchange: (state, {payload}) => {
      state.exchange = payload;
    },
  },
  extraReducers: builder => {
    builder
      //** Balance Sheet Accounts **
      .addCase(addNewCashdeskDirective.fulfilled, (state, {payload}) => {
        if (!payload?.directive) return;
        state.cashdeskDirective = payload.directive;
      })
      // .addCase(uploadBankClientStatements.fulfilled, (state, {payload}) => {
      //   // state.cashdeskDirective = payload.directive;
      // })

      .addCase(fetchAllBankTransactions.fulfilled, (state, {payload}) => {
        if (!payload) return;
        state.bankTransactions = payload.currentPage > 1 ? [...state.bankTransactions, ...payload.data] : payload.data;
      })
      .addCase(fetchAllAccountsBalances.fulfilled, (state, {payload}) => {
        if (!payload) return;
        state.turnovers = payload.currentPage > 1 ? [...state.turnovers, ...payload.data] : payload.data;
      })
      .addCase(fetchBankClientFilters.fulfilled, (state, {payload}) => {
        state.bankClientFilters = payload;
      })
      .addCase(fetchBankTransaction.fulfilled, (state, {payload}) => {
        state.bankTransaction = payload;
      })
      .addCase(alignCounterpartyAcc.fulfilled, (state, {payload}) => {
        state.bankTransaction = payload;
      })
      .addCase(alignUntilFurtherNotice.fulfilled, (state, {payload}) => {
        state.bankTransaction = payload;
      })

      .addCase(fetchAllBankClientStatements.fulfilled, (state, {payload}) => {
        if (!payload) return;
        state.bankClientStatements =
          payload.currentPage > 1 ? [...state.bankClientStatements, ...payload.data] : payload.data;
      })
      .addCase(fetchAllCounterpartyTypes.fulfilled, (state, {payload}) => {
        state.counterpartyTypes = payload;
      })

      .addCase(completeBankTransaction.fulfilled, (state, {payload}) => {
        state.bankTransaction = payload;
      })

      //*** Manual transactions */
      .addCase(fetchAllManualTransactions.fulfilled, (state, {payload}) => {
        if (!payload) return;
        state.manualTransactions = payload.data;
      })
      // .addCase(createManualTransaction.fulfilled, (state, {payload}) => {
      //   state.manualTransaction = payload;
      // })
      .addCase(saveManualTransaction.fulfilled, (state, {payload, meta}) => {
        // state.manualTransaction = payload;
        state.manualTransactions = state.manualTransactions?.find(
          ({statementId}) => statementId === meta.arg.statementId,
        )
          ? state.manualTransactions.map(transaction => {
              if (transaction.statementId === meta.arg.statementId) {
                return payload;
              }
              return transaction;
            })
          : [payload, ...state.manualTransactions];
      })
      .addCase(completeManualTransaction.fulfilled, (state, {meta}) => {
        // state.manualTransaction = null;
        state.manualTransactions = state.manualTransactions?.filter(({statementId}) => statementId !== meta.arg);
      })
      .addCase(cancelManualTransaction.fulfilled, (state, {meta}) => {
        // state.manualTransaction = null;
        state.manualTransactions = state.manualTransactions?.filter(({statementId}) => statementId !== meta.arg);
      })

      //*** VED Directive ***/
      .addCase(fetchAllVedDirectives.fulfilled, (state, {payload}) => {
        state.vedDirectives =
          payload?.currentPage > 1 ? [...(state?.vedDirectives ?? []), ...(payload?.data ?? [])] : payload?.data ?? [];
      })
      .addCase(fetchVedDirectivesFilters.fulfilled, (state, {payload}) => {
        state.vedDirectivesFilters = payload?.data;
      })
      .addCase(fetchVedDirective.fulfilled, (state, {payload}) => {
        state.currentVedDirective = payload?.directive ?? payload ?? null;
      })

      .addCase(fetchVedPaymentDocTypes.fulfilled, (state, {payload}) => {
        state.paymentDocTypes = payload ?? [];
      })
      .addCase(fetchFinOrder.fulfilled, (state, {payload}) => {
        if (!payload) return;
        if (payload.orderId > 0) {
          state.currentVedOrderId = payload.orderId;
        }
      })
      .addCase(addNewFinOrder.fulfilled, (state, {payload}) => {
        if (payload?.directive) {
          state.currentVedDirective = payload.directive;
        }
        if (payload?.order) {
          state.finOrder = payload.order;
        }
      })

      //*** Cargo Directives ***/
      .addCase(fetchAllCargoDirectives.fulfilled, (state, {payload}) => {
        state.cargoDirectives =
          payload?.currentPage > 1
            ? [...(state?.cargoDirectives ?? []), ...(payload?.data ?? [])]
            : payload?.data ?? [];
      })
      .addCase(fetchAllStatementDirectives.fulfilled, (state, {payload}) => {
        state.statementDirectives =
          payload?.currentPage > 1
            ? [...(state?.statementDirectives ?? []), ...(payload?.data ?? [])]
            : payload?.data ?? [];
      })
      .addCase(fetchCargoDirectivesFilters.fulfilled, (state, {payload}) => {
        state.cargoDirectivesFilters = payload?.data;
      })
      .addCase(fetchStatementDirectivesFilters.fulfilled, (state, {payload}) => {
        state.statementDirectivesFilters = payload?.data;
      })
      .addCase(fetchCargoDirective.fulfilled, (state, {payload}) => {
        state.currentCargoDirective = payload?.directive ?? payload ?? null;
      })

      //*** Payments */
      .addCase(fetchAllPayments.fulfilled, (state, {payload}) => {
        if (!payload || !payload.data) return;
        state.payments = payload.data;
      })
      .addCase(fetchAllPaymentDocs.fulfilled, (state, {payload}) => {
        if (!payload || !payload.data) return;
        state.paymentDocs = payload.data;
        // state.payments = payload.data.flatMap(({payments}) => payments);
      })
      .addCase(createPayment.fulfilled, (state, {meta, payload}) => {
        if (!payload || !payload.data) return;
        state.payments.unshift(payload.data);
        state.paymentDocs = state.paymentDocs.map(paymentDoc => {
          if (paymentDoc.docId === meta.arg.docId) {
            return {
              ...paymentDoc,
              payments: [payload.data, ...(paymentDoc.payments ?? [])],
            };
          }
          return paymentDoc;
        });
        // state.paymentDocs = state.paymentDocs.map(paymentDoc => {
        //   if (paymentDoc.docId === meta.arg.docId) {
        //     paymentDoc.payments = [...(paymentDoc.data ?? []), ...(paymentDoc.payments ?? [])];
        //   }
        //   return paymentDoc;
        // });
      })
      .addCase(sendPayment.fulfilled, (state, {payload}) => {
        if (!payload?.data) return;
        const index = state.payments.findIndex(doc => doc.paymentId === payload.data.paymentId);
        if (index !== -1) {
          state.payments[index] = payload.data;
          state.paymentDocs = state.paymentDocs?.map(doc => {
            if (doc.docId === payload.data.docId) {
              doc.payments = doc.payments?.map(payment => {
                if (payment?.paymentId === payload.data.paymentId) {
                  return payload.data;
                }
                return payment;
              });
            }
            return doc;
          });
        }
      })
      .addCase(removePayment.fulfilled, (state, {meta}) => {
        state.payments = state.payments.filter(({paymentId}) => paymentId !== meta.arg.paymentId);
        state.paymentDocs = state.paymentDocs.map(paymentDoc => {
          const newPayments = paymentDoc.payments.filter(({paymentId}) => paymentId !== meta.arg.paymentId);
          return {...paymentDoc, payments: newPayments};
        });
      })
      .addCase(fetchPaymentDoc.fulfilled, (state, {payload}) => {
        if (!payload) return;
        const index = state.paymentDocs.findIndex(doc => doc.docId === payload.docId);
        if (index !== -1) {
          state.paymentDocs[index] = payload;
        }
      })
      .addCase(createPaymentDoc.fulfilled, (state, {payload}) => {
        if (!payload?.data) return;
        state.paymentDocs.unshift(payload.data);
      })
      .addCase(updatePaymentDoc.fulfilled, (state, {payload}) => {
        if (!payload?.data) return;
        const index = state.paymentDocs.findIndex(doc => doc.docId === payload.data.docId);
        if (index !== -1) {
          state.paymentDocs[index] = payload.data;
        }
      })
      .addCase(removePaymentDoc.fulfilled, (state, {meta}) => {
        state.paymentDocs = state.paymentDocs.filter(({docId}) => docId !== meta.arg.docId);
      })
      .addCase(uploadPaymentDocFile.fulfilled, (state, {payload, meta}) => {
        if (!payload) return;
        const updatedDocId = meta.arg.docId;
        state.paymentDocs = state.paymentDocs.map(invoice => {
          if (invoice.docId === updatedDocId) {
            return {...invoice, files: [...(invoice?.files ?? []), payload.data]};
          }
          return invoice;
        });
      })
      .addCase(removePaymentDocFile.fulfilled, (state, {meta}) => {
        const deletedFileId = meta.arg.fileId;
        state.paymentDocs = state.paymentDocs.map(invoice => {
          invoice.files = invoice.files.filter(file => file.fileId !== deletedFileId);
          return invoice;
        });
      })

      //*** Cash exchanges */
      .addCase(fetchExchange.fulfilled, (state, {payload}) => {
        if (!payload) return;
        state.exchange = payload;
      })
      .addCase(fetchAllExchanges.fulfilled, (state, {payload}) => {
        if (!payload) return;
        state.allExchanges = payload?.data || [];
      })
      .addCase(createExchange.fulfilled, (state, {payload}) => {
        if (!payload) return;
        state.exchange = payload;
        state.allExchanges = [payload, ...(state.allExchanges || [])];
      })
      .addCase(updateExchange.fulfilled, (state, {payload}) => {
        if (!payload) return;
        state.exchange = payload;
        state.allExchanges = state.allExchanges?.map(exchange => {
          return exchange?.exchangeId === payload?.exchangeId ? {...(exchange || {}), ...(payload || {})} : exchange;
        });
      })
      .addCase(runExchange.fulfilled, (state, {payload}) => {
        if (!payload) return;
        state.exchange = payload;
        state.allExchanges = state.allExchanges?.map(exchange => {
          return exchange?.exchangeId === payload?.exchangeId ? {...(exchange || {}), ...(payload || {})} : exchange;
        });
      })
      .addCase(deleteExchange.fulfilled, (state, action) => {
        state.exchange = null;
        state.allExchanges = state.allExchanges?.filter(({exchangeId}) => exchangeId !== action.meta?.arg?.exchangeId);
      })

      //fulfilled matcher
      .addMatcher(
        action => action.type.startsWith(FIN_BLOCK_STORE_NAME) && action.type.endsWith("/fulfilled"),
        state => handleFulfilled(state),
      )
      //pending matcher
      .addMatcher(
        action => action.type.startsWith(FIN_BLOCK_STORE_NAME) && action.type.endsWith("/pending"),
        state => handlePending(state),
      )
      //rejected matcher
      .addMatcher(
        action => action.type.startsWith(FIN_BLOCK_STORE_NAME) && action.type.endsWith("/rejected"),
        (state, {error}) => handleRejected(state, error),
      )
      //default
      .addDefaultCase(() => {});
  },
});

function handleFulfilled(state) {
  state.loading = false;
  state.error = false;
}

function handlePending(state) {
  state.loading = true;
  state.error = false;
}

function handleRejected(state, error) {
  state.loading = false;
  state.error = error;
}

const {actions, reducer} = FinBlockSlice;

export const {
  clearCashdeskDirective,
  setCurrentVedDirectiveId,
  setCurrentVedOrderId,
  setCurrentCargoDirectiveId,
  setCurrentCargoOrderId,
  clearPayments,
  setCurrentDocId,
  setPaymentDocSelect,
  deselectPaymentDoc,
  setCurentSchema,
  setCurrentPaymentDocument,
  setRateMatrix,
  clearRateMatrix,
  setCurrentExchange,
} = actions;

export default reducer;

// *** Selectors ***
export const selectCashdeskDirective = state => state[FIN_BLOCK_STORE_NAME].cashdeskDirective;

export const selectBankClientStatements = state => state[FIN_BLOCK_STORE_NAME].bankClientStatements;
export const selectBankTransactions = state => state[FIN_BLOCK_STORE_NAME].bankTransactions;
export const selectBankTransaction = state => state[FIN_BLOCK_STORE_NAME].bankTransaction;
export const selectBankClientFilters = state => state[FIN_BLOCK_STORE_NAME].bankClientFilters;
export const selectFinBlockLoading = state => state[FIN_BLOCK_STORE_NAME].loading;
export const selectCounterpartyTypes = state => state[FIN_BLOCK_STORE_NAME].counterpartyTypes;
export const selectAllTurnovers = state => state[FIN_BLOCK_STORE_NAME].turnovers;
export const selectAllManualTransactions = state => state[FIN_BLOCK_STORE_NAME].manualTransactions;
export const selectVedDirectives = state => state[FIN_BLOCK_STORE_NAME].vedDirectives;

export const selectCurrentVedDirective = state => state[FIN_BLOCK_STORE_NAME].currentVedDirective;
export const selectVedPaymentDocTypes = state => state[FIN_BLOCK_STORE_NAME].paymentDocTypes;

export const selectVedDirectivesFilters = state => state[FIN_BLOCK_STORE_NAME].vedDirectivesFilters;

export const selectCurrentDirectiveId = state => state[FIN_BLOCK_STORE_NAME].currentDirectiveId;
export const selectCurrentOrderId = state => state[FIN_BLOCK_STORE_NAME].currentOrderId;
export const selectVedDirectiveId = state => state[FIN_BLOCK_STORE_NAME].currentVedDirectiveId;
export const selectVedOrderId = state => state[FIN_BLOCK_STORE_NAME].currentVedOrderId;

export const selectCargoDirectiveId = state => state[FIN_BLOCK_STORE_NAME].currentCargoDirectiveId;
export const selectCargoOrderId = state => state[FIN_BLOCK_STORE_NAME].currentCargoOrderId;

// export const selectManualTransaction = state => state[FIN_BLOCK_STORE_NAME].manualTransaction;

export const selectCargoDirectives = state => state[FIN_BLOCK_STORE_NAME].cargoDirectives;
export const selectCurrentCargoDirective = state => state[FIN_BLOCK_STORE_NAME].currentCargoDirective;
export const selectCargoDirectivesFilters = state => state[FIN_BLOCK_STORE_NAME].cargoDirectivesFilters;

export const selectStatementDirectives = state => state[FIN_BLOCK_STORE_NAME].statementDirectives;
export const selectCurrentStatementDirective = state => state[FIN_BLOCK_STORE_NAME].currentStatementDirective;
export const selectStatementDirectivesFilters = state => state[FIN_BLOCK_STORE_NAME].statementDirectivesFilters;

//**Payments */
export const selectPayments = state => state[FIN_BLOCK_STORE_NAME].payments;
export const selectPaymentDocs = state => state[FIN_BLOCK_STORE_NAME].paymentDocs;
export const selectCurrentDocId = state => state[FIN_BLOCK_STORE_NAME].currentDocId;
export const selectCurrentPaymentDocument = state => state[FIN_BLOCK_STORE_NAME].currentPaymentDocument;
export const selectCurrentPaymentId = state => state[FIN_BLOCK_STORE_NAME].currentPaymentId;

//**Schema */
export const selectCurrentSchema = state => state[FIN_BLOCK_STORE_NAME].currentSchema;

//** Rate matrix snapshot */
export const selectRateMatrix = state => state[FIN_BLOCK_STORE_NAME].rateMatrix;

//*** Cash exchanges */
export const selectAllExchanges = state => state[FIN_BLOCK_STORE_NAME].allExchanges;
export const selectExchange = state => state[FIN_BLOCK_STORE_NAME].exchange;
